import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import DownLoadBG from '../../../assets/download/financing_download_bg.png'
import Rectangle from '../../../assets/download/financing_download_rectangle.png'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import React from 'react'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMHomeDownload: React.FC = () => {

    const { t } = useTranslation()

    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                height: '750px',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${DownLoadBG})`,
            }}
        >
            {/* Moto */}
            
            <Box sx={{
                paddingTop: '100px',
                paddingLeft: '50px',
            }}>
                <Image src={Rectangle} width={500} height={500} alt='' preview={false}></Image>
            </Box>


            {/* DownLoad */}
            <Box sx={{
                flex: '1',
                flexDirection: 'column',
                alignContent: 'center',
                display: 'flex',
                justifyContent: 'center'
            }}>
                {/* description */}
                <Box sx={{
                    paddingLeft: '100px',
                    paddingRight: '72px'
                }}>
                    <Typography fontWeight={700} fontSize={'32px'} color={'#141F39'}>
                        {t('t70')}
                    </Typography>

                    <Typography paddingTop={'15px'} fontWeight={400} fontSize={'16px'} color={'#141F39'}>
                        {t('t71')}
                    </Typography>
                    {/*app shop */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'left',
                    alignContent: 'center',
                    paddingTop: '65px'
                }}>
                    <Box
                        onClick={clickGooglePlay}
                        sx={{
                            paddingLeft: '0px',
                            paddingRight: '12px',
                            cursor: 'pointer',
                        }}>
                        <Image src={GooglePlay} width={150} height={50} alt='' preview={false}></Image>
                    </Box>

                    <Box
                        onClick={clickAppStore}
                        sx={{
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            cursor: 'pointer',
                        }}>
                        <Image src={AppStore} width={150} height={50} alt='' preview={false}></Image>
                    </Box>

                    <Box
                        onClick={clickAppGallery}
                        sx={{
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            cursor: 'pointer',
                        }}>
                        <Image src={AppGallery} width={150} height={50} alt='' preview={false}></Image>
                    </Box>
                </Box>
                </Box>

                

            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeDownload
